import { render, staticRenderFns } from "./demandContactsCheck.vue?vue&type=template&id=64e3a636&scoped=true&"
import script from "./demandContactsCheck.vue?vue&type=script&lang=js&"
export * from "./demandContactsCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e3a636",
  null
  
)

export default component.exports